import styled, { css } from "styled-components"
import ButtonComponent2023 from "@rentspree/component-2023.components.atoms.button"

import {
  COLOR,
  BUTTON_HEIGHT,
  BUTTON_SHADOW,
  FLEX_CENTER,
  HOVER_SHADOW,
  XL_BUTTON_PADDING,
  XL_BUTTON_BORDER_RADIUS,
  LARGE_BUTTON_BORDER_RADIUS,
  SMALL_BUTTON_PADDING,
  SMALL_BUTTON_BORDER_RADIUS,
} from "styles/style-constants"
import { greenGradient, blueGradient, transparentBtn } from "./button-colors"

export const extraLargeBtn = css`
  height: 55px;
  font-size: 20px;
  font-weight: bold;
  font-family: Merriweather, sans-serif;
  padding: 0px ${XL_BUTTON_PADDING};
  border-radius: ${XL_BUTTON_BORDER_RADIUS};
  @media (max-width: 520px) {
    padding: 0px 40px;
  }
`
export const largeBtn = css`
  width: 100%;
  border-radius: ${LARGE_BUTTON_BORDER_RADIUS};
`
export const smallBtn = css`
  padding: 0px ${SMALL_BUTTON_PADDING};
  border-radius: ${SMALL_BUTTON_BORDER_RADIUS};
`

export const Button2023Component = (
  <ButtonComponent2023 variant="contained"></ButtonComponent2023>
)

const Button = styled.button`
  ${FLEX_CENTER};
  appearance: none;
  border: none;
  position: relative;
  overflow: hidden;
  z-index: 0;
  height: ${BUTTON_HEIGHT};
  cursor: pointer;
  ${(props) => props.transparent && transparentBtn};
  ${(props) => props.blueGradient && blueGradient};
  ${(props) => props.large && largeBtn};
  ${(props) => props.small && smallBtn};
  ${(props) => props.extraLarge && extraLargeBtn};
  ${(props) => props.greenGradient && greenGradient};
  ${(props) => props.shadow && `box-shadow: ${BUTTON_SHADOW}`};
  ${(props) => props.shadowLevel2 && `box-shadow: ${HOVER_SHADOW}`};
  ${(props) => props.fontSize && `font-size: ${props.fontSize}`};
  ${(props) => props.semiBold && `font-weight: 600`};
  ${(props) => props.margin && `margin: ${props.margin}`};
  ${(props) => props.minWidth && `min-width: ${props.minWidth}px`};
  ${(props) => props.fontWeight && `font-weight: ${props.fontWeight}`};
  &:hover > .background {
    transition: all, 0.5s;
    transform: translateX(50%);
  }
  ${(props) =>
    props.tWidth &&
    `
  @media (max-width: 991px) {
    width: ${props.tWidth};
  }`}
  ${(props) =>
    props.mWidth &&
    `
  @media (max-width: 520px) {
    width: ${props.mWidth};
  }`} 
  ${(props) =>
    props.disabled &&
    `cursor: not-allowed;
  box-shadow: 0 0 0 0;
  color: white;`};
`

export default Button
